<template>
  <div class="grid">
    <div
      class="p-input col-12"
      :class="startClass"
    >
      <label
        for="start"
        class=" required-input"
      >{{ $t('entity.barcode.start') }}</label>
      <InputNumber
        id="start"
        v-model="v$.startModel.$model"
        class="w-full"
        :min="0"
      />
      <div v-if="v$.startModel.$error">
        <span
          v-for="error in v$.startModel.$errors"
          :key="error.$uid"
          class="error-msg"
        >
          {{ $t(error.$message) }}
        </span>
      </div>
    </div>
    <div
      class="p-input col-12"
      :class="numberClass"
    >
      <label
        for="number"
        class="required-input"
      >{{ $t('entity.barcode.end') }}</label>
      <InputNumber
        id="number"
        v-model="v$.numberModel.$model"
        class="w-full"
        :min="1"
        :max="1000"
      />
      <div v-if="v$.numberModel.$error">
        <p
          v-for="error in v$.numberModel.$errors"
          :key="error.$uid"
          class="error-msg"
        >
          {{ $t(error.$message) }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import {maxBarcode, required} from "@/i18n/i18nValidators";
import {useVuelidate} from "@vuelidate/core";
import InputNumber from "primevue/inputnumber";

export default {
  name: 'BarcodeRangeInput',
  components: {
    InputNumber
  },
  props: {
    start: {
      type: Number,
      default: null,
    },
    number: {
      type: Number,
      default: null,
    },
    valid: {
      type: Boolean,
      default: true,
    },
    startClass: {
      type: String,
      default: '',
    },
    numberClass: {
      type: String,
      default: '',
    },
  },
  emits: ['update:start', 'update:number', 'update:valid'],
  validations: {
    startModel: {
      required,
    },
    numberModel: {
      required,
      maxBarcode,
    },
  },
  setup() {
    return {
      v$: useVuelidate(),
    }
  },
  computed: {
    startModel: {
      get() {
        return this.start;
      },
      set(value) {
        this.$emit("update:start", value);
      }
    },

    numberModel: {
      get() {
        return this.number;
      },
      set(value) {
        this.$emit("update:number", value);
      }
    },

    validModel: {
      get() {
        return this.valid;
      },
      set(value) {
        this.$emit("update:valid", value);
      }
    }
  },
  mounted() {
    this.$watch('v$.$invalid', (value) => {
      this.validModel = !value;
    })

    this.v$.$validate();
  }

}
</script>
